// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-ddcbde0e] .order-placed-modal{max-width:450px;overflow:hidden}.image[data-v-ddcbde0e]{align-items:center;display:flex;justify-content:center}.image img[data-v-ddcbde0e]{max-height:224px;width:auto}.notice[data-v-ddcbde0e]{line-height:1.5em;margin:1em 0}.toggler[data-v-ddcbde0e]{margin-top:1em;text-align:left;width:100%}.toggler[data-v-ddcbde0e] .el-checkbox__label{font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
